import type { SwitchProps } from 'antd';
import { Form, FormInstance } from 'antd';
import { useEffect, useRef } from 'react';

import { isExist } from '@util/data/is-exist';

import { StyledSwitch } from './form-switcher.style';

interface FormSwitcherProps extends SwitchProps {
  form: FormInstance;
  name: string | string[];
  defaultChecked?: boolean;
  onChange?: (value: boolean) => void;
}

export const FormSwitcher = ({ form, name, onChange, defaultChecked = false, ...props }: FormSwitcherProps) => {
  const checked = Form.useWatch(name, form);
  const prevValue = useRef<boolean>(false);
  const isInitialized = useRef<boolean>(false);

  const handleChange = (value: boolean) => {
    form.setFieldValue(name, value);
    if (isInitialized.current && isExist(prevValue.current) && isExist(onChange)) {
      onChange(value);
    }
    prevValue.current = value;
  };

  useEffect(() => {
    if (!isExist(checked)) {
      handleChange(defaultChecked);
    }
    isInitialized.current = true;
  }, [defaultChecked, checked]);

  return <StyledSwitch {...props} checked={checked} onChange={handleChange} />;
};
